module.exports = __webpack_public_path__ + "img/T712.a2e2881f.jpg";